import React, { useState } from "react";
import KeyboardArrowUpRounded from "@mui/icons-material/KeyboardArrowUpRounded";
import { Popover } from "@mui/material";

import SoftBox from "../SoftBox";
import ProfileDrawer from "./ProfileDrawer";

const ProfilePopover = ({
  darkMode = false,
  viewOnly = false,
  expands = false,
  // Defaults keep the original open-upward-right-aligned behavior; pass
  // overrides (e.g. from a narrow, left-docked container) to avoid the
  // popover being right-aligned to a trigger near that container's edge,
  // which pushes it off the left of the viewport instead of over the page.
  anchorOrigin = { vertical: "top", horizontal: "right" },
  transformOrigin = { vertical: "bottom", horizontal: "right" },
  // Anchors the popover to a wider ancestor (e.g. the whole profile card)
  // instead of just the small chevron trigger, so it lines up with that
  // container's edge rather than the trigger's.
  containerRef = null,
}) => {
  const [anchorPosition, setAnchorPosition] = useState(null);

  const handleOpenWs = (event) => {
    const target = containerRef?.current || event.currentTarget;
    const rect = target.getBoundingClientRect();
    // Measured directly off the DOM at click time and handed to the Popover
    // as a fixed point, rather than a live anchorEl for it to re-measure —
    // inside the sidebar's mobile drawer (an animated, transformed overlay)
    // that re-measurement was landing the menu near the top-left of the
    // page instead of next to the trigger that was actually clicked.
    setAnchorPosition({
      top: anchorOrigin.vertical === "top" ? rect.top : rect.bottom,
      left: anchorOrigin.horizontal === "left" ? rect.left : rect.right,
    });
    event.stopPropagation();
  };

  const handleCloseDrawer = () => {
    setAnchorPosition(null);
  };

  const openDrawerMenu = Boolean(anchorPosition);

  return (
    <>
      <SoftBox
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "max-content",
          minWidth: "max-content",
          padding: 0,
          color: darkMode || !expands ? "#FFF" : "#000",
          fontSize: expands ? "2vh" : "1.5rem",
          right: expands ? "1vw" : "16px",
          top: expands ? "4.5vh" : "60px",
          "&:hover": {
            cursor: "pointer",
          },
          borderRadius: "0px !important",
        }}
        onClick={handleOpenWs}
      >
        <KeyboardArrowUpRounded />
      </SoftBox>
      <Popover
        id="footerMenu"
        open={openDrawerMenu}
        onClose={handleCloseDrawer}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition || { top: 0, left: 0 }}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={{
          style: {
            ...(darkMode && { background: "primary.darker" }),
            boxShadow: "none!important",
            padding: "0rem",
            ...(expands
              ? {
                  width: "18vw",
                }
              : {
                  width: "234px",
                }),
            borderRadius: 0,
          },
        }}
      >
        <ProfileDrawer />
      </Popover>
    </>
  );
};

export default ProfilePopover;
